import { Component, OnDestroy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import {ErrorPopupData, ErrorPopupService} from "@dabnet-kamu/libs/ui/shared/services/error-popup.service";
import { Subscription } from 'rxjs';
import {FaIconComponent, FaIconLibrary} from "@fortawesome/angular-fontawesome";
// DKM-5454 Cedric: eski hâli
// import {faCheckCircle, faExclamationTriangle, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {faCheckCircle, faExclamationCircle, faExclamationTriangle, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {DxButtonModule, DxPopupModule, DxToolbarModule} from "devextreme-angular";
@Component({
  selector: 'dk-error-popup',
  standalone: true,
  imports: [CommonModule, DxPopupModule, FaIconComponent, DxButtonModule, DxToolbarModule],
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
})
export class ErrorPopupComponent implements OnDestroy {
  private destroyRef = inject(DestroyRef);
  visible = false;
  data: ErrorPopupData = { title: '', message: '', type: 'error' };
  private subscription: Subscription;

  constructor(private popupService: ErrorPopupService, library: FaIconLibrary) {
    // DKM-5454 Cedric: eski hâli — warning şablonundaki 'exclamation-circle' kayıtlı değildi (ikon çıkmıyor, konsola hata düşüyordu)
    // library.addIcons(faExclamationTriangle, faCheckCircle, faInfoCircle);
    library.addIcons(faExclamationTriangle, faExclamationCircle, faCheckCircle, faInfoCircle);

    this.subscription = this.popupService.popupState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.data = data;
      this.visible = true;
    });
  }

  close() {
    this.visible = false;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
